import * as types from './mutations-type'
import moment from 'moment'

const mutations = {
  [types.CHECK_DEVICE] (state, screenWidth) {
    state.screen = screenWidth < 768 ? 'mobile' : 'pc'
  },
  [types.SET_COMPONENTS_CONFIG] (state, data) {
    state.comConfig = data
  },
  [types.SET_CON_KEYINFO] (state, data) {
    state.conKeyInfo = data
  },
  [types.SET_SPEAKERS_MAP] (state, data) {
    state.speakerConfig = data
  },
  [types.PARSE_CON_DATA] (state, data) {
    // combine data
    let isPastHot = Number(data.info.hotRecommand)

    if (isPastHot === 1 && Array.isArray(data.recommend_data.recommend_data.speakers) && data.recommend_data.recommend_data.speakers.length) {
      data.speakers = data.speakers.concat(data.recommend_data.recommend_data.speakers)
    }

    if (isPastHot === 1 && Array.isArray(data.recommend_data.recommend_data.topics) && data.recommend_data.recommend_data.topics.length) {
      data.topics = data.topics.concat(data.recommend_data.recommend_data.topics)
    }

    if (isPastHot === 1 && Array.isArray(data.recommend_data.recommend_data.lectures) && data.recommend_data.recommend_data.lectures.length) {
      data.lectures = data.lectures.concat(data.recommend_data.recommend_data.lectures)
    }

    // speaker
    let speakers = {}
    data.speakers.forEach((item, index) => {
      speakers[item.id] = item
    })

    // tags
    let tags = {}
    data.tag_details.forEach((item, index) => {
      tags[item.tag_id] = item
    })

    // topic
    let topics = {}
    let training
    data.topics.forEach((item, index) => {
      if (Array.isArray(item.producerIds)) {
        item.producerIds.forEach(sid => {
          if (speakers[sid]) speakers[sid].topicId = item.id
          item.speakers ? (
            Array.isArray(item.speakers) ? item.speakers = item.speakers.concat(speakers[sid]) : item.speakers = [].concat(speakers[sid])
          ) : item.speakers = [].concat(speakers[sid])
        })
        item.speaker = speakers[item.producerIds[0]] || {}
      }
      if (Number(item.typeid) === 3 && Boolean(item.is_previous) !== true) training = item
      topics[item.id] = item
    })

    // lecture
    let lectures = {}
    data.lectures.forEach((item, index) => {
      if (Array.isArray(item.speakerIds)) {
        // speaker 中加 lecture 索引
        // speaker 中加 search 索引
        item.speakers = []
        item.search = []
        item.search.push(item.title)
        item.speakerIds.forEach(sid => {
          if (speakers[sid]) {
            if (Array.isArray(speakers[sid].lectures)) {
              speakers[sid].lectures.push(item)
            } else {
              speakers[sid].lectures = []
              speakers[sid].lectures.push(item)
            }
            if (Array.isArray(speakers[sid].lectureIds)) {
              speakers[sid].lectureIds.push(item.id)
            } else {
              speakers[sid].lectureIds = []
              speakers[sid].lectureIds.push(item.id)
            }
            speakers[sid].lectureId = item.id
            item.speakers.push(speakers[sid])
            // item.search.push(speakers[sid].name)
          }
        })
        // tag 中加 lecture/search 索引
        if (item.tag_ids) {
          item.tag_ids.forEach(sid => {
            if (tags[sid]) {
              if (Array.isArray(tags[sid].lectureIds)) {
                tags[sid].lectureIds.push(item.id)
              } else {
                tags[sid].lectureIds = []
                tags[sid].lectureIds.push(item.id)
              }
              item.search.push(tags[sid].name)
            }
          })
        }
        // #old version# lecture 中加 speaker 索引
        item.speaker = speakers[item.speakerIds[0]] || {}
      }
      if (item.topicId) {
        // lecture 中加 topic 索引
        item.topic = topics[item.topicId]
      }
      lectures[item.id] = item
    })

    // 专题中的议题按时间排序
    data.topics.forEach((item, index) => {
      item.sLectureIds = []
      item.lectureIds && item.lectureIds.forEach(id => { item.sLectureIds.push(id) })
      item.sLectureIds.sort((aid, bid) => {
        let atime, btime
        if (lectures[aid] && lectures[bid]) {
          atime = moment(lectures[aid].beginTime).unix()
          btime = moment(lectures[bid].beginTime).unix()
        }
        if (atime > btime) {
          return 1
        } else {
          return -1
        }
      })
    })

    // partner
    let partners = {}
    data.partners.forEach((item, index) => {
      if (!partners[item.typeid]) partners[item.typeid] = []
      partners[item.typeid].push(item)
    })
    // info
    data.info.date = moment(data.info.beginTime).utcOffset('+08:00').format('YYYY年MM月DD日-') + moment(data.info.endTime).utcOffset('+08:00').format('DD日')
    data.info.trainingDate = moment(data.info.beginTimeTraining).utcOffset('+08:00').format('YYYY年MM月DD日-') + moment(data.info.endTimeTraining).utcOffset('+08:00').format('DD日')
    data.info.btnApply.remainDays = moment(data.info.btnApply.deadline).diff(moment(), 'days') + 1
    data.info.btnApply.discountPrice /= 100
    data.info.menus = data.info.menus.filter(m => m.display)
    let scheduleDayIndex = 0 // 会议是第几天
    data.info.scheduleDays.forEach(s => {
      if (s.type === 'conf') {
        s.index = scheduleDayIndex
        scheduleDayIndex++
      }
    })

    // hot map data
    let hotTopicsArr = []
    let guestsArr = []
    let hotLecturesArr = []

    if (data.recommend_data) {
      if (Array.isArray(data.recommend_data.recommend_ids.topics_rec)) hotTopicsArr = data.recommend_data.recommend_ids.topics_rec.map(id => { return topics[id] })
      if (Array.isArray(data.recommend_data.recommend_ids.speakers_rec)) guestsArr = data.recommend_data.recommend_ids.speakers_rec.map(id => { return speakers[id] })
      if (Array.isArray(data.recommend_data.recommend_ids.lectures_rec)) hotLecturesArr = data.recommend_data.recommend_ids.lectures_rec.map((tid) => { return lectures[tid] })
    }

    // fill state
    state.speakers = speakers
    state.speakersArr = data.speakers
    state.topics = topics
    state.topicsArr = data.topics.filter(t => Number(t.typeid) !== 3) // 过滤掉培训
    if (training) state.training = training
    state.currrentLecturesArr = data.lectures
    state.lectures = lectures
    state.tags = tags
    state.tagsArr = data.tag_details
    state.schedules = data.schedules
    state.partners = partners
    state.partnersArr = data.partners
    state.articles = data.articles
    state.info = data.info
    state.config = data.config
    state.ads = data.ads
    state.ppt_list = data.ppt_list
    state.tags = tags

    // file state hot
    state.isPastHot = isPastHot
    state.guestsArr = guestsArr // speaker 首页推荐部分
    state.hotTopicsArr = hotTopicsArr // topics 首页推荐部分
    state.hotLecturesArr = hotLecturesArr // lectures 首页推荐部分

    // data ready
    state.isDataReady = true
  }
}

export default mutations
